(function() {
  'use strict';

  const RETAIL_SUFFIX = '-r';

  function init() {
    // KZK preorder: bu bir on siparis urunuyse wholesale add-to-cart popup'ini baglama;
    // on siparis popup'i (preorder-popup.js) add-to-cart'i devralacak.
    if (document.querySelector('#preorders[data-preorders="true"]')) {
      console.log('[ProductCartPopup] Preorder urunu tespit edildi, wholesale popup atlandi');
      return;
    }

    // Check if we're on a product page
    const productHandle = window.ProductCartPopupConfig?.handle;
    if (!productHandle) return;

    // Add to Cart butonlarını bul
    const addToCartSelectors = [
      'form[action*="/cart/add"] button[type="submit"]',
      'form[action*="/cart/add"] input[type="submit"]',
      '.product-form__submit',
      'button[name="add"]',
      '[data-add-to-cart]',
      '.btn--add-to-cart',
      '.product-form__cart-submit',
      '#AddToCart',
      '.add-to-cart-button'
    ];

    let addToCartBtn = null;
    let productForm = null;

    for (const selector of addToCartSelectors) {
      const btn = document.querySelector(selector);
      if (btn) {
        addToCartBtn = btn;
        productForm = btn.closest('form');
        break;
      }
    }

    if (!addToCartBtn) {
      console.log('[ProductCartPopup] Add to Cart button not found');
      return;
    }

    console.log('[ProductCartPopup] Intercepting Add to Cart for:', productHandle);

    // Form submit'i engelle
    if (productForm) {
      productForm.addEventListener('submit', handleAddToCart);
    }

    // Buton click'i de engelle
    addToCartBtn.addEventListener('click', handleAddToCart);
  }

  function handleAddToCart(e) {
    const productHandle = window.ProductCartPopupConfig?.handle;

    // Quickview modal yüklü mü kontrol et
    if (!window.QuickviewModal || typeof window.QuickviewModal.open !== 'function') {
      console.warn('[ProductCartPopup] QuickviewModal not available, allowing default behavior');
      return;
    }

    // Varsayılan davranışı engelle
    e.preventDefault();
    e.stopPropagation();

    console.log('[ProductCartPopup] Opening popup for:', productHandle);

    // Popup'ı aç
    window.QuickviewModal.open(productHandle);
  }

  // DOM hazır olunca başlat
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
